import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle() { this.navbarElement?.classList?.toggle("is--active") }

  get navbarElement() { return document.querySelector(".leftside-menu.leftside-menu-detached") }
}
